import { useEffect, useState, useCallback } from "react";
import "./News.css";
import { CallApiGetNews } from "../../../Api/Enforcement";
import { Path } from "../../../Api/Path";
import { clientNewsDetail } from "../../../Api/SubUrl";
import imageError from "../../../Css/img/backGround1.jpg";

function NewsComponent() {
  const NEWS = "NEWS";
  const EVENT = "EVENT";
  const GUID = "GUID";

  const [search, setSearch] = useState("");
  const [type, setType] = useState(NEWS);
  const [listCover, setListCover] = useState([]);

  const handleCallApiNew = useCallback(
    (searchText = "") => {
      const param = {
        type: type,
        page: 0,
        pageSize: 100,
        search: searchText,
      };
      CallApiGetNews(param, (res) => {
        if (res.Status === "success") {
          const data = res.Response.data;
          setListCover(data.Items);
        }
      });
    },
    [type]
  );

  const handleChangPage = (ID) => {
    const url = `${clientNewsDetail}${ID}`;
    window.open(url, "_blank");
  };

  const handleSearch = useCallback(() => {
    handleCallApiNew(search);
  }, [search, handleCallApiNew]);

  useEffect(() => {
    handleCallApiNew();
  }, [type, handleCallApiNew]);

  return (
    <div className="news">
      <div className="nav">
        <ul>
          <li>
            <p onClick={() => setType(NEWS)}>Tin tức</p>
          </li>
          <li>
            <p onClick={() => setType(EVENT)}>Sự kiện</p>
          </li>
          <li>
            <p onClick={() => setType(GUID)}>Hướng dẫn</p>
          </li>
        </ul>
        <div className="search">
          <input
            type="text"
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Nhập từ khóa tìm kiếm"
          />
          <button onClick={handleSearch}>+</button>
        </div>
      </div>
      <div className="list-news">
        {listCover?.map((item, index) => {
          if (index === 0) {
            return (
              <div key={index} className="item hot">
                <div onClick={() => handleChangPage(item.ID)} className="cover">
                  <p target="_blank" title={item.Title}>
                    <img
                      src={Path.imageCDN + item.Img}
                      alt={item.Title}
                      onError={(e) => {
                        e.target.src = imageError;
                      }}
                    />
                  </p>
                </div>
                <div className="detail">
                  <p target="_blank" alt={item.Title}>
                    <h3 title={item.Title}>{item.Title}</h3>
                  </p>
                  <p className="desc">{item.shortText}</p>
                  <a
                    href={`${clientNewsDetail}${item.ID}`}
                    alt={item.Title}
                    title={item.Title}
                    rel="noopener noreferrer"
                    target="_blank"
                    className="viewmore"
                  >
                    Xem thêm »
                  </a>
                </div>
              </div>
            );
          }
          return null;
        })}

        <div className="list mCustomScrollbar _mCS_1">
          <div
            id="style-1"
            className="mCustomScrollBox mCS-light mCSB_vertical mCSB_inside"
            style={{ maxHeight: "300px" }}
            tabIndex="0"
          >
            <div
              id="mCSB_1_container"
              className="mCSB_container"
              style={{ position: "relative", top: 0, left: 0 }}
              dir="ltr"
            >
              {listCover?.map((item, index) => {
                return (
                  <div key={index} className="item ">
                    <div
                      onClick={() => handleChangPage(item.ID)}
                      className="cover"
                    >
                      <p target="_blank" title={`S6 - HD4567 - ${item.Title}`}>
                        <img
                          src={Path.imageCDN + item.Img}
                          alt={`S6 - HD4567 - ${item.Title}`}
                          onError={(e) => {
                            e.target.src = imageError;
                          }}
                          className="mCS_img_loaded"
                        />
                      </p>
                    </div>
                    <div className="detail">
                      <p target="_blank" alt={`S6 - HD4567 - ${item.Title}`}>
                        <h3 title={`S6 - HD4567 - ${item.Title}`}>
                          {item.Title}
                        </h3>
                      </p>
                      <p className="desc">{item.shortText}</p>
                      <p target="_blank" className="viewmore">
                        Xem thêm »
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
            <div
              id="mCSB_1_scrollbar_vertical"
              className="mCSB_scrollTools mCSB_1_scrollbar mCS-light mCSB_scrollTools_vertical"
              style={{ display: "block" }}
            >
              <div className="mCSB_draggerContainer">
                <div
                  id="mCSB_1_dragger_vertical"
                  className="mCSB_dragger"
                  style={{
                    position: "absolute",
                    minHeight: "30px",
                    display: "block",
                    height: "55px",
                    maxHeight: "290px",
                    top: "0px",
                  }}
                >
                  <div
                    className="mCSB_dragger_bar"
                    style={{ lineHeight: "30px" }}
                  ></div>
                </div>
                <div className="mCSB_draggerRail"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NewsComponent;
